<template>
    {{ money }}
</template>

<script setup>
import { computed } from 'vue';

const { amount } = defineProps({
    amount: {
        type: Number,
        required: true,
    },
});

const money = computed(() => {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(amount);
});
</script>
